module.exports = __webpack_public_path__ + "static/img/solve-c.9c5c7c83.png";